import React from "react";
import { Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";
import MultipleSelect from "features/Admin/components/NewMultipleSelect";

const AvailabilityForm = ({ element, liveFactory, updateLiveCenters }) => (
	<div>
		<Field id="live" name="live" customlabel='Activer la fonctionnalité "Live"' component={Checkbox} required />
		<MultipleSelect factory={liveFactory} update={updateLiveCenters} />
	</div>
);

export default AvailabilityForm;
